package com.milta.core.localization.translations.ro

import com.milta.core.localization.CommonStrings

internal val Common = CommonStrings(
    appName = "Milta",
    ok = "OK",
    cancel = "Anulare",
    confirm = "Confirmă",
    save = "Salvează",
    delete = "Șterge",
    back = "Înapoi",
    loading = "Se încarcă…",
    retry = "Reîncearcă",
    creationInProgressDoNotClose = "Creare în curs, nu închideți fereastra",
    processingStepSent = "Document trimis",
    processingStepReading = "Citirea documentului",
    processingStepFinding = "Identificarea livrărilor",
    processingStepChecking = "Verificarea adreselor",
    processingUsualDuration = "De obicei 20–40 de secunde. Rămâneți pe acest ecran, ne ocupăm noi de rest.",
    processingLongWait = "Documentul conține multe informații, analiza durează puțin mai mult decât de obicei. Totul funcționează, continuăm.",
    processingInProgressSince = "În curs de %1",
    processingFinishedIn = "Finalizată în %1",
    processingDeliveriesFound = "%1 livrări găsite",
    processingDeliveriesFoundOne = "1 livrare găsită",
    processingAddressesChecked = "%1 din %2 adrese",
    addressVerifiedBadge = "✓ Adresă verificată",
    addressNeedsReviewBadge = "⚠ Adresă de verificat",
    addressFoundLine = "Găsită: %1",
    language = "Limbă",
    welcomeTitle = "Bun venit la Milta",
    welcomeSubtitle = "Asistentul dvs. inteligent de livrare",
    alreadyHaveAccount = "Am deja un cont",
    createAccount = "Creează un cont",
    continueWithGoogle = "Continuă cu Google",
    continueWithApple = "Continuă cu Apple",
    oauthErrorGeneric = "A apărut o eroare la conectare. Încercați din nou.",
    oauthAppleWebComingSoon = "Conectarea cu Apple va fi disponibilă în curând pe web.",
    oauthDriverAccountNotAllowedOnWeb = "Conturile de șofer nu pot accesa tabloul de bord web. Conectați-vă din aplicația mobilă.",
    oauthAccountNotFoundOnWeb = "Nu a fost găsit niciun cont Milta pentru acest cont Google.",
    errorOffline = "Fără conexiune la internet.",
    navTourneesDuJour = "Curse de azi",
    navAjouterUneTournee = "Adaugă o cursă",
    navHistoriqueDesPreuves = "Istoric livrări",
    navParametres = "Setări",
    sidebarRoleManagerLabel = "Manager",
    noDeliveriesYetTitle = "Nicio livrare încă",
    noDeliveriesYetSubtitle = "Atingeți „Adăugați livrări” pentru a adăuga",
    optimizationUnavailableExplanation = "Doriți să creați cursa fără optimizare, sau să reîncercați?",
    createWithoutOptimizationAction = "Creează fără optimizare",
    gpsAppSheetTitle = "Alege o aplicație de navigație",
    addressSearchingLabel = "Se caută…",
    clearTimeFieldAction = "Șterge",
    clearTimeFieldConfirmTitle = "Ștergeți ora?",
    clearTimeFieldConfirmMessage = "Ora curentă va fi eliminată. Puteți seta oricând una nouă.",
    updateRequiredTitle = "Actualizare obligatorie",
    updateRequiredMessage = "Este disponibilă o nouă versiune Milta. Actualizați aplicația pentru a o folosi în continuare.",
    updateInstalledVersionLabel = "Instalată",
    updateAvailableVersionLabel = "Disponibilă",
    updateNowButton = "Actualizează",
    updateDataKeptNote = "Traseele și livrările dvs. sunt păstrate.",
    updateSendingPendingOne = "Se trimite 1 livrare validată offline…",
    updateSendingPendingMany = "Se trimit {count} livrări validate offline…",
)
